export const CLASS_SCROLL_SPY = 'scroll-spy';
export const SELECTOR_SCROLL_SPY = `.${CLASS_SCROLL_SPY}`;
export const SCROLL_SPY_OFFSET = 15;
